export default {
    init: (state, payload) => {
        state.type = payload.type;
        state.itemid = payload.itemid;
        state.declid = payload.declid;
        state.declinable = payload.declinable;
    },
};
